module.exports = __webpack_public_path__ + "img/gas.3723e7ad.svg";